@if (document) {
  <div class="document-icon-wrapper">
    <span class="document-icon mb-icon mb-icon-documents-detail"></span>
    <span [class]="documentIconClasses">{{ document.filetypeName }}</span>
  </div>
  <div class="document-content">
    <div class="document-headline" [innerHTML]="document.title"></div>
    <div class="document-footer">
      <div class="document-meta">
        <ul class="meta-items">
          @if (document.pageCount) {
            <li class="meta-item">
              {{ 'PAGES_N' | translate: { count: document.pageCount } }}
            </li>
          }
          <li class="meta-item">{{ document.filetypeName }}</li>
          <li class="meta-item">{{ document.filesize | fileSize }}</li>
        </ul>
      </div>
      <mb-action-container
        [buttonItems]="actions"
        [resource]="document"
        (actionClick)="actionClick.emit({ action: $event, resource: document })"
      >
      </mb-action-container>
    </div>
  </div>
}
